import { Coding } from "@medplum/fhirtypes";
import type { Suspect as ApiSuspect } from "../../../../../api/suspects";
import { suspectMapping } from "../../../shared-components/fhir-sections/suspects/shared";
import { ICD_10_SYSTEM } from "../../components/coding-badge";

export type SuspectRowData = ApiSuspect & {
  condition: string;
  code: string;
  coding?: Coding;
  displayName: string;
  logicTooltip: string;
};

/**
 * Generate table rows for suspects section using API data
 * Reuses V1 logic for data transformation
 */
export function getSuspectRows({ suspects }: { suspects?: ApiSuspect[] }): SuspectRowData[] {
  return (
    suspects?.map(suspect => {
      const mapping = suspectMapping[suspect.group] || {
        displayName: suspect.group,
        logicTooltip: "No additional information available",
      };

      return {
        ...suspect,
        condition: suspect.icd10ShortDescription,
        code: suspect.icd10Code,
        coding: suspect.icd10Code
          ? {
              system: ICD_10_SYSTEM,
              code: suspect.icd10Code,
            }
          : undefined,
        displayName: mapping.displayName,
        logicTooltip: mapping.logicTooltip,
      };
    }) || []
  );
}
